import { render } from "./PasswordlessLogin.vue?vue&type=template&id=25a6603e&scoped=true&ts=true"
import script from "./PasswordlessLogin.vue?vue&type=script&lang=ts"
export * from "./PasswordlessLogin.vue?vue&type=script&lang=ts"

import "./PasswordlessLogin.vue?vue&type=style&index=0&id=25a6603e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a6603e"]])

export default __exports__